module.exports = __webpack_public_path__ + "img/Holt_Michael2020-07-18.ba357a4a.jpg";